module.exports = __webpack_public_path__ + "static/media/A25.00df198e.jpg";